import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router } from '@angular/router';
import { StorageService } from '../storage-service/storage.service';

@Injectable({ providedIn: 'root' })
export class SessionTimeoutService {
  public isUserActive = true;

  constructor(
    private idle: Idle, 
    private _router: Router,
    private _storage: StorageService
  ) {
    this.setupIdleLogout();
  }

  setupIdleLogout(): void {
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onTimeout.subscribe(() => {
      this.isUserActive = false;
      this.invalidateToken();
    });

    this.idle.watch();
  }

  private invalidateToken(): void {
    // Remove the token to trigger 401 errors on next API call
    this._storage.removeToken();
    
    // Force a page reload to trigger the AppErrorHandler
    // This will cause API calls to fail with 401, triggering the confirmation dialog
    window.location.reload();
  }

  logout(): void {
    sessionStorage.removeItem('id_token');
    this._router.navigate(['/login']);
  }

  public resetTimer(): void {
    console.log('[SessionTimeoutService] Session timer reset');
    this.isUserActive = true;
    this.idle.watch();
  }

  public setIdleTimeout(seconds: number): void {
    console.log('[SessionTimeoutService] Session timer set to', seconds, 'seconds');
    this.idle.setIdle(seconds);
    this.idle.setTimeout(1);
    this.idle.watch();
  }
}
